export default __webpack_public_path__ + "static/media/Skyline.303b44cc.gif";